import {
    Checkbox,
    Chip,
    Container,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    Input,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
    Typography,
    Divider
} from "@material-ui/core";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import React from "react";
import "../styles/deckCreationStyles.css";
import "../styles/masterStyles.css";
import { SaspButton } from "./SaspButton";
import { CounterWidget } from "./CounterWidget"
import ModalIcon from "./ModalIcon";

import { CopyrightWidget } from ".";
import { getThisYear } from "../common";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
        backgroundColor: '#00567a',
        color: '#fff' 
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
}));

function getStyles(index, key, theme) {
    return {
      fontWeight:
        key.indexOf(index) === -1
            ? theme.typography.fontWeightRegular
            : theme.typography.fontWeightMedium,
    };
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        },
    },
};

export const DeckFormWidget = props => {
    const [name, changeName] = React.useState("");
    const [summary, changeSummary] = React.useState("");
    const [checkYears, setCheckedYears] = React.useState(props.yearsObj);
    const [checkAreas, setCheckedAreas] = React.useState(props.areaObj);
    const [checkKeyword, setCheckedKeyword] = React.useState(props.keywords);
    const [checkQuestions] = React.useState(props.questionObj);
    const [myYears, setMyYears] = React.useState([]);
    const [myAreas, setMyAreas] = React.useState([]);
    const classes = useStyles();
    const theme = useTheme();
    const selectYears = Object.keys(props.yearsObj).reverse(); 

    const [state, setState] = React.useState({
        isHome: true,
        openBook: true,
        isPublic: false,
        isSpaced: false,
        blankDeck: false,
        flashCards: false,
        questionCount: props.questionCount,
        deckEnds: 1
    });


    const handleChange = name => event => {
        //TODO refactor the handle changes to replace/update property instead of adding new "true" ones--w.o. mutating state
        //TODO refactor this handlechange to be faster
        if (name.toString().charAt(0) === 2) {
            setCheckedYears({ ...checkYears, [name]: event.target.checked });
        } else {
            setCheckedAreas({ ...checkAreas, [name]: event.target.checked });
        }
    };

    const updateChange = (obj) => {        
        switch(obj.type) {
            case 'year': {
                checkYears[obj.name] = obj.bool;
                break;
            }
            case 'area': {
                checkAreas[obj.name] = obj.bool;
                break;
            }
        }
    }

    const updateCount = async () => {
        let obj = {
            mcid: props.user_details.mcid,
            key: props.user_details.key,
            yearvar: myYears,
            gamemode: state.openBook ? 3 : 4,
            areavar: myAreas,
        };
        let c = await props.getQuestionCount(obj);
        setState({...state, questionCount: c});
    }

    const handleSwitchChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    }

    const handleYearChange = (event) => {
        let val = event.target.value;
        setMyYears(val);
        let test = Object.keys(checkYears);
        for (const i in test) {
            updateChange({type: 'year', name: test[i].toString(), bool: val.includes(test[i].toString())});
        }
    }

    const handleAreaChange = (event) => {
        let val = event.target.value;        
        setMyAreas(val);
        let test = Object.keys(checkAreas)
        for (const i in test) {
            updateChange({type: 'area', name: test[i].toString(), bool: val.includes(test[i].toString())});
        }
    }

    //TODO refactor to incorporate these into 1 handlechange function
    const handleKeyChange = name => event => {
        setCheckedKeyword({ ...checkKeyword, [name]: event.target.checked });
    };

    const handleNameChange = event => {
        changeName(event.target.value);
    };

    const handleSummaryChange = event => {
        changeSummary(event.target.value);
    };

    const mapYears = props => {
        let i = -1;
        return props.SASPYears.map((year, index) => {
            if (year.useravailable === 1) {
                i++;
                return (
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={checkYears[year.ProductYear].value}
                                onChange={handleChange(year.ProductYear)}
                                value={checkYears[year.ProductYear].value}
                            />
                        }
                        label={year.ProductYear}
                    />
                );
            }
        });
    };

    const mapAreas = props => {
        return props.availableAreas.map((area, index) => {
            return (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checkAreas[area]}
                            onChange={handleChange(area.QArea)}
                            value={checkAreas[area]}
                        />
                    }
                    label={area.AreaDescription}
                />
            );
        });
    };

    //TODO repair this. It is not working/updating the checkboxes correctly
    const mapKeywords = props => {
        return Object.keys(props.keywords).map((keyword, index) => {
            return (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checkKeyword[keyword].value}
                            onChange={handleKeyChange(keyword)}
                            value={checkKeyword[keyword].value}
                        />
                    }
                    label={keyword}
                />
            );
        });
    };

    const icon = props.icons;

    return (
        <Container className="createDeckFormContainer aua-overflow" maxWidth="xl" style={{marginBottom: "64px"}}>
            <Grid container className="mainContainer">
                <Grid item xs={12} className="anchor margin-top-8">
                    <CounterWidget 
                        count={state.questionCount}
                        textColor="#fff"
                        backgroundColor="#00567a"
                    /> 
                    {/* <h3 className="text-blue">Create Deck</h3> */}
                    <Typography className="DividerText">Create Deck</Typography>
                    <Divider className="SASPDivider margin-bottom-16" />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label="Deck Name"
                        defaultValue={props.name !== "" ? props.name : ""}
                        onChange={handleNameChange}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label="Deck Summary"
                        defaultValue={props.summary !== "" ? props.summary : ""}
                        onChange={handleSummaryChange}
                        multiline
                        rowsMax={10}
                        rows={4}
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="label-SASPYears">Subscription Years</InputLabel>
                        <Select
                            labelId="label-SASPYears"
                            id="aua-SASPYears"
                            multiple
                            value={myYears}
                            onChange={handleYearChange}
                            onBlur={updateCount}
                            input={<Input id="select-SASPYears" />}
                            renderValue={(selected) => (
                                <div className={classes.chips}>
                                    {selected.map((value) => (
                                        <Chip key={value} label={value} className={classes.chip} />
                                    ))}
                                </div>
                            )}
                            MenuProps={MenuProps}
                        >
                            {selectYears.map((year) => (
                                <MenuItem key={year} value={year} getStyles={(year, myYears, theme)}>
                                    {year}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Typography className="hidden" varient="h6">Keywords</Typography>
                <Grid className="hidden" item xs={12}>
                    <FormGroup>
                        <div>{mapKeywords(props)}</div>
                    </FormGroup>
                </Grid>

                <Grid item xs={12}>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="label-UroAreas">Topics</InputLabel> 
                        <Select
                            labelId="label-UroAreas"
                            id="aua-UroAreas"
                            multiple
                            value={myAreas}
                            onChange={handleAreaChange}
                            onBlur={updateCount}
                            input={<Input id="select-UroAreas" />}
                            renderValue={(selected) => (
                                <div className={classes.chips}>
                                    {selected.map((value) => (
                                        <Chip key={value} label={value} className={classes.chip} />
                                    ))}
                                </div>
                            )}
                            MenuProps={MenuProps}
                        >
                            {props.availableAreas.map((item) => (
                                <MenuItem key={item.QArea} value={item.QArea} getStyles={(item.QArea, myAreas, theme)}>
                                    {item.AreaDescription}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} className="anchor" style={{marginTop:"48px"}}>
                    {/* <FormLabel 
                        component="legend" 
                        className="margin-16 text-blue text-strong">
                            Options
                    </FormLabel> */}
                    <Grid item xs={12}>
                        <Typography className="DividerText">Options</Typography>
                        <Divider className="SASPDivider margin-bottom-24" />
                    </Grid>
                    
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch checked={state.isHome} onChange={handleSwitchChange} name="isHome" />}
                                    label="Add to Home"
                                />
                            </FormGroup>
                        </FormControl>

                        <ModalIcon
                            title={'Home Deck'}
                            icon={'info'}
                            body={icon.home}
                            color={'#7c878e'}
                            className={"margin-left-16"}
                        />
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch checked={state.openBook} onChange={handleSwitchChange} name="openBook"  />}
                                    label="Open Book"
                                />
                            </FormGroup>
                        </FormControl>

                        <ModalIcon
                            title={'Open Book'}
                            icon={'info'}
                            body={icon.open}
                            color={'#7c878e'}
                            className={"margin-left-16"}
                        />
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch checked={state.isSpaced} onChange={handleSwitchChange} name="isSpaced"  />}
                                    label="Spaced Learning"
                                />
                            </FormGroup>
                        </FormControl>

                        <ModalIcon
                            title={'Spaced Learning'}
                            icon={'info'}
                            body={icon.spaced}
                            color={'#7c878e'}
                            className={"margin-left-16"}
                        />
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch checked={state.isPublic} onChange={handleSwitchChange} name="isPublic" />}
                                    label="Public"
                                />
                            </FormGroup>
                        </FormControl>

                        <ModalIcon
                            title='Public Deck'
                            icon='info'
                            body={icon.public}
                            color='#7c878e'
                            className="margin-left-16"
                        />
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch checked={state.flashCards} onChange={handleSwitchChange} name="flashCards" />}
                                    label="Flashcards" 
                                />
                            </FormGroup>
                        </FormControl>

                        <ModalIcon
                            title='Flashcards'
                            icon='info'
                            body={icon.flashcards}
                            color='#7c878e'
                            className="margin-left-16"
                        />
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch checked={state.deckEnds} onChange={handleSwitchChange} name="deckEnds"  />}
                                    label="Deck Ends"
                                />
                            </FormGroup>
                        </FormControl>

                        <ModalIcon
                            title='Deck Ends'
                            icon='info'
                            body={icon.deckEnds}
                            color='#7c878e'
                            className="margin-left-16"
                        />
                    </div>
                </Grid>
                
                <Grid item xs={12}>
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch checked={state.blankDeck} onChange={handleSwitchChange} name="blankDeck"  />}
                                    label="Blank Deck"
                                />
                            </FormGroup>
                        </FormControl>
                    </div>
                </Grid>

                <div className="margin-top-12 padding-bottom-24 margin-bottom-16">
                    <SaspButton
                        className="text-white"
                        onClick={() => props.gapFunc({
                            years: checkYears, 
                            areas: checkAreas, 
                            keywords: checkKeyword,  
                            name: name, 
                            summary: summary,
                            isHome: state.isHome,
                            isPublic: state.isPublic,
                            isSpaced: state.isSpaced, 
                            flashCards: state.flashCards,
                            openBook: state.openBook,
                            blankDeck: state.blankDeck
                        })}
                    >
                        Create Deck
                    </SaspButton>

                    {/* <SaspButton
                        className="text-white margin-left-12"
                        onClick={() =>
                            props.sendQuestions(
                                checkYears, 
                                checkAreas,
                                checkKeyword,
                                name,
                                summary
                            )
                        }
                    >
                        Get Questions
                    </SaspButton> */}
                </div>
            </Grid>

            <CopyrightWidget 
                begin={2020}
                year={getThisYear()}
                textAlign={'center'}
                className="margin-top-48 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
            />
        </Container>
    );
};

//TODO add validation on submit button/disabled until ready...i.e. at least 1 button must be clicked
//TODO style this page